<template>
  <el-dialog
    top="50px"
    width="500px"
    :title="item ? 'Sửa tài khoản' : 'Thêm tài khoản'"
    :visible="visible"
    :show-close="!callingAPI"
    append-to-body
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="email"
            label="Địa chỉ email"
          >
            <el-input
              v-model="form.email"
              :disabled="!!item"
              placeholder="Nhập địa chỉ email"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="phone"
            label="Số điện thoại"
          >
            <el-input
              v-model="form.phone"
              placeholder="Nhập số điện thoại"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="avatar_url"
            label="Avatar"
          >
            <el-input
              v-model="form.avatar_url"
              placeholder="Nhập link avatar"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="first_name"
            label="Họ"
          >
            <el-input
              v-model="form.first_name"
              placeholder="Nhập họ"
            />
          </el-form-item>
        </el-col>
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="last_name"
            label="Tên"
          >
            <el-input
              v-model="form.last_name"
              placeholder="Nhập tên"
            />
          </el-form-item>
        </el-col>
        <el-col
          v-if="isCreate"
          :lg="24"
          :span="24"
        >
          <el-form-item
            prop="password"
            label="Mật khẩu"
          >
            <el-input
              v-model="form.password"
              type="password"
              placeholder="Nhập mật khẩu"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
        >Đóng</el-button
      >
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Lưu</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { notification } from "@/utils/common";
import accountServices from "@/services/account";
import PATTERNS from "@/config/patterns.js";

export default {
  name: "DataFormPopup",
  props: {
    item: Object,
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      form: {
        avatar_url: "",
        email: "",
        phone: "",
        first_name: "",
        last_name: "",
        password: "",
      },
      callingAPI: false,
    };
  },
  computed: {
    isCreate() {
      return !this.item || !this.item.id;
    },
    payloadData() {
      if (this.isCreate) {
        return this.form
      }
      delete this.form.password;
      return {
        ...this.item,
        ...this.form
      };
    },
    rules() {
      const result = {
        email: [
          {
            required: true,
            email: `Email là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
          {
            pattern: PATTERNS.EMAIL,
            message: `Email không hợp lệ.`,
            trigger: ["blur", "change"],
          }
        ],
        phone: [
          {
            pattern: PATTERNS.PHONE,
            message: `Số điện thoại không hợp lệ.`,
            trigger: ["blur", "change"],
          }
        ],
        password: [
          {
            required: true,
            message: `Mật khẩu là trường bắt buộc.`,
            trigger: ["blur", "change"],
          },
        ]
      };
      return result;
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      if (this.item) {
        this.form = {
          avatar_url: this.item.avatar_url,
          email: this.item.email,
          phone: this.item.phone,
          first_name: this.item.first_name,
          last_name: this.item.last_name,
        };
      } else {
        this.form = {
          avatar_url: "",
          email: "",
          phone: "",
          first_name: "",
          last_name: "",
          password: "",
        };
      }
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          accountServices[!this.isCreate ? "update" : "create"](
            this.payloadData
          )
            .then(() => {
              this.callingAPI = false;
              this.$emit("reload");
              notification(
                this,
                "success",
                !this.isCreate ? "update" : "create",
                "danh mục"
              );
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                !this.isCreate ? "update" : "create",
                "danh mục"
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
